(() => {
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width: 768px)');
 const instances=new Map();
 function init(root=document){
  root.querySelectorAll('[data-home-hero]').forEach(hero=>{
   if(instances.has(hero))return;
   const abort=new AbortController(),options={signal:abort.signal};
   const slides=[...hero.querySelectorAll('[data-home-slide]')],buttons=[...hero.querySelectorAll('[data-slide-pick]')],pause=hero.querySelector('[data-slide-pause]');
   const progressBars=buttons.map(b=>b.querySelector('[data-tab-progress]'));
   let selected=0,paused=reduced.matches,visible=true,timer,startTime=Date.now(),elapsedPaused=0;
   const duration=Math.max(5000,Number(hero.dataset.interval)||8000);
   function setProgress(p){progressBars.forEach((bar,i)=>{if(!bar)return;bar.style.width=i===selected?(Math.round(p*100)+'%'):'0%';});}
   function schedule(){hero.dataset.paused=String(paused||!visible||reduced.matches);clearInterval(timer);if(!paused&&visible&&!reduced.matches&&!mobile.matches&&hero.dataset.autoplay==='true'&&slides.length>1){timer=setInterval(()=>{const elapsed=elapsedPaused+(Date.now()-startTime);if(elapsed>=duration){select((selected+1)%slides.length);}else{setProgress(Math.min(1,elapsed/duration));}},50);}}
   let fadeTimer;
   function select(index){
    if(index===selected&&!slides.some(s=>s.classList.contains('is-leaving')))return;
    selected=index;
    buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    startTime=Date.now();
    elapsedPaused=0;
    setProgress(0);
    const currentlyVisible=slides.find(s=>!s.hidden);
    const next=slides[index];
    if(reduced.matches||!currentlyVisible||!next||currentlyVisible===next){
     clearTimeout(fadeTimer);
     slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.classList.remove('is-leaving','is-entering');});
     return;
    }
    clearTimeout(fadeTimer);
    slides.forEach((slide,i)=>{if(slide!==currentlyVisible&&slide!==next){slide.hidden=true;slide.classList.remove('is-leaving','is-entering');}});
    currentlyVisible.classList.remove('is-entering');
    currentlyVisible.classList.add('is-leaving');
    fadeTimer=setTimeout(()=>{
     currentlyVisible.hidden=true;
     currentlyVisible.classList.remove('is-leaving');
     next.classList.add('is-entering');
     next.hidden=false;
     void next.offsetWidth;
     const raf=typeof requestAnimationFrame==='function'?requestAnimationFrame:(cb=>setTimeout(cb,16));
     raf(()=>next.classList.remove('is-entering'));
    },420);
   }
   function updatePause(){if(pause){pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?pause.dataset.play:pause.dataset.pause;}schedule();}
   buttons.forEach((button,i)=>button.addEventListener('click',()=>{select(i);schedule();},options));
   if(pause)pause.addEventListener('click',()=>{paused=!paused;updatePause();},options);
   hero.addEventListener('focusin',()=>{elapsedPaused+=Date.now()-startTime;clearInterval(timer);},options);hero.addEventListener('focusout',()=>{startTime=Date.now();schedule();},options);
   hero.addEventListener('mouseenter',()=>{elapsedPaused+=Date.now()-startTime;clearInterval(timer);},options);hero.addEventListener('mouseleave',()=>{startTime=Date.now();schedule();},options);
   const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();});observer.observe(hero);
   reduced.addEventListener('change',()=>{paused=reduced.matches;updatePause();},options);mobile.addEventListener('change',schedule,options);
   select(0);updatePause();instances.set(hero,()=>{abort.abort();observer.disconnect();clearInterval(timer);clearTimeout(fadeTimer);});
  });
  root.querySelectorAll('[data-home-catalog]').forEach(section=>{
   if(instances.has(section))return;const abort=new AbortController();
   const cards=[...section.querySelectorAll('[data-formula-pick]')],panels=[...section.querySelectorAll('[data-formula-panel]')];
   cards.forEach((card,i)=>card.addEventListener('click',event=>{if(mobile.matches)return;event.preventDefault();cards.forEach((c,j)=>{c.classList.toggle('is-active',i===j);c.setAttribute('aria-expanded',String(i===j));});panels.forEach((p,j)=>p.hidden=i!==j);},{signal:abort.signal}));
   cards[0]?.classList.add('is-active');
   const index=section.querySelector('.nb-home-index');if(index&&mobile.matches)index.open=false;
   instances.set(section,()=>abort.abort());
  });
  function count(node){
   const target=parseFloat(node.getAttribute('data-count'))||0;
   const dur=900,t0=(typeof performance!=='undefined'&&performance.now)?performance.now():Date.now();
   const raf=typeof requestAnimationFrame==='function'?requestAnimationFrame:(cb=>setTimeout(cb,16));
   const tick=timestamp=>{
    const now=(typeof timestamp==='number'&&!isNaN(timestamp))?timestamp:((typeof performance!=='undefined'&&performance.now)?performance.now():Date.now());
    const k=Math.min(1,(now-t0)/dur);
    const eased=1-Math.pow(1-k,3);
    node.textContent=String(Math.round(target*eased));
    if(k<1)raf(tick);
   };
   raf(tick);
  }
  function initReveals(root=document){
   if(reduced.matches)return;
   const dist=26,vh=(typeof window!=='undefined'&&window.innerHeight)||800;
   const reveals=(root.matches&&root.matches('[data-reveal]')?[root]:[]).concat([...root.querySelectorAll('[data-reveal]')]);
   const hidden=[];
   reveals.forEach((n,i)=>{
    if(n.dataset.revealInit)return;
    n.dataset.revealInit='true';
    n.style.transition='opacity 560ms cubic-bezier(.2,.7,.3,1), transform 560ms cubic-bezier(.2,.7,.3,1)';
    n.style.transitionDelay=((i%5)*70)+'ms';
    if(n.getBoundingClientRect().top>vh*0.92){
     n.style.opacity='0';
     n.style.transform='translateY('+dist+'px)';
     hidden.push(n);
    }else{
     setTimeout(()=>{
      n.style.transitionDelay='';
      n.style.transition='';
      if(n.style.transform==='none')n.style.transform='';
     },900);
    }
   });
   const countNodes=(root.matches&&root.matches('[data-count]')?[root]:[]).concat([...root.querySelectorAll('[data-count]')]);
   const counters=countNodes.filter(c=>{
    if(c.dataset.countInit)return false;
    c.dataset.countInit='true';
    c.textContent='0';
    return true;
   });
   const watch=hidden.concat(counters);
   if(!watch.length)return;
   const show=n=>{
    if(n.hasAttribute('data-count'))return count(n);
    n.style.opacity='1';
    n.style.transform='none';
    setTimeout(()=>{
     n.style.transitionDelay='';
     n.style.transition='';
     if(n.style.transform==='none')n.style.transform='';
    },900);
   };
   if(typeof IntersectionObserver!=='function'){
    watch.forEach(show);
    return;
   }
   let fired=false;
   const io=new IntersectionObserver(entries=>{
    fired=true;
    entries.forEach(e=>{
     if(e.isIntersecting){
      show(e.target);
      io.unobserve(e.target);
     }
    });
   },{threshold:0.05});
   watch.forEach(n=>io.observe(n));
   const safety=setTimeout(()=>{if(!fired){watch.forEach(show);io.disconnect();}},1600);
   if(safety&&safety.unref)safety.unref();
  }
  initReveals(root);
 }
 init();document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const [node,cleanup]of instances)if(event.target.contains(node)){cleanup();instances.delete(node);}});
 document.addEventListener('shopify:section:select',event=>{const button=event.target.querySelector('[data-slide-pause][aria-pressed="false"]');button?.click();});
})();
